module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "4"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("\n            " + _vm._s(_vm.$route.name) + "\n          ")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalData) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.reviewedFilter ||
        _vm.Filter.BilledRemark ||
        _vm.Filter.MblNoFilter ||
        _vm.Filter.HblNoFilter ||
        _vm.Filter.ContainerNoFilter ||
        _vm.Filter.JobNoFilter ||
        _vm.Filter.remarkFilter ||
        _vm.Filter.additionalTaskFilter ||
        _vm.Filter.expenseFilter ||
        _vm.Filter.menifestationFilter ||
        _vm.Filter.SlineFilter ||
        _vm.Filter.finalBillingStatusFilter ||
        _vm.Filter.billingTypeFilter ||
        _vm.Filter.clearStatusFilter ||
        _vm.Filter.statusFilter ||
        _vm.Filter.clientFilter ||
        _vm.Filter.slineIdFilter ||
        _vm.Filter.commonFilter ||
        _vm.Filter.createdByFilter ||
        _vm.Filter.clearedByFilter ||
        _vm.Filter.branchFilter ||
        _vm.Filter.createdAtRange.startDate ||
        _vm.Filter.createdAtRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.reviewedFilter ||
    _vm.Filter.BilledRemark ||
    _vm.Filter.MblNoFilter ||
    _vm.Filter.HblNoFilter ||
    _vm.Filter.ContainerNoFilter ||
    _vm.Filter.JobNoFilter ||
    _vm.Filter.remarkFilter ||
    _vm.Filter.additionalTaskFilter ||
    _vm.Filter.expenseFilter ||
    _vm.Filter.menifestationFilter ||
    _vm.Filter.SlineFilter ||
    _vm.Filter.finalBillingStatusFilter ||
    _vm.Filter.billingTypeFilter ||
    _vm.Filter.clearStatusFilter ||
    _vm.Filter.statusFilter ||
    _vm.Filter.clientFilter ||
    _vm.Filter.slineIdFilter ||
    _vm.Filter.commonFilter ||
    _vm.Filter.createdByFilter ||
    _vm.Filter.clearedByFilter ||
    _vm.Filter.branchFilter ||
    _vm.Filter.createdAtRange.startDate ||
    _vm.Filter.createdAtRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getLockPanel.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('getLockPanel', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.getLockPanel)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.AllModule_ids.length) + ")")]), _vm._v(" "), (_vm.AllModule_ids.length > 0) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.ProceedReview
    }
  }, [_vm._v("Proceed Review")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdAtRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdAtRange", $$v)
      },
      expression: "Filter.createdAtRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Reviewed")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.paymentType,
      "option-value": "pTypeVal",
      "option-text": "pTypeText",
      "placeholder": "Select Reviewed"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.reviewedFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "reviewedFilter", $$v)
      },
      expression: "Filter.reviewedFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Sline")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.paymentType,
      "option-value": "pTypeVal",
      "option-text": "pTypeText",
      "placeholder": "Select Payment Sline"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.SlineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SlineFilter", $$v)
      },
      expression: "Filter.SlineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Expense")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.paymentType,
      "option-value": "pTypeVal",
      "option-text": "pTypeText",
      "placeholder": "Select Expense Sline"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.expenseFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "expenseFilter", $$v)
      },
      expression: "Filter.expenseFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Additional Task")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.paymentType,
      "option-value": "pTypeVal",
      "option-text": "pTypeText",
      "placeholder": "Select Additional Task"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.additionalTaskFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "additionalTaskFilter", $$v)
      },
      expression: "Filter.additionalTaskFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Clear Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.paymentClearType,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Clear Status"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clearStatusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clearStatusFilter", $$v)
      },
      expression: "Filter.clearStatusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Billing Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.BillingStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Status"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.finalBillingStatusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "finalBillingStatusFilter", $$v)
      },
      expression: "Filter.finalBillingStatusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Billing Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.BillingTypeStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Billing Type"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.billingTypeFilter),
      callback: function($$v) {
        _vm.billingTypeFilter = $$v
      },
      expression: "billingTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "ShippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.slineIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "slineIdFilter", $$v)
      },
      expression: "Filter.slineIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientFilter",
      "option-value": "clientId",
      "option-text": "ClientName",
      "placeholder": "Select Client Name"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("MBL No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search MBL No Filter",
      "id": "MblNoFilter",
      "name": "MblNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.MblNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "MblNoFilter", $$v)
      },
      expression: "Filter.MblNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("HBL No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search HBL No Filter",
      "id": "HblNoFilter",
      "name": "HblNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.HblNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "HblNoFilter", $$v)
      },
      expression: "Filter.HblNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Container No Filter",
      "id": "ContainerNoFilter",
      "name": "ContainerNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.ContainerNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ContainerNoFilter", $$v)
      },
      expression: "Filter.ContainerNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("JOB No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search JOB No Filter",
      "id": "JobNoFilter",
      "name": "JobNoFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.JobNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "JobNoFilter", $$v)
      },
      expression: "Filter.JobNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "commonFilter",
      "name": "commonFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Remark Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "text",
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Common Filter",
      "id": "remarkFilter",
      "name": "remarkFilter",
      "autocomplete": "off"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.remarkFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "remarkFilter", $$v)
      },
      expression: "Filter.remarkFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Created User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "createdByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.createdByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "createdByFilter", $$v)
      },
      expression: "Filter.createdByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v(" Cleared By User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "clearedByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Cleared User"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.clearedByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clearedByFilter", $$v)
      },
      expression: "Filter.clearedByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_c('b', [_vm._v("Reviewed By User ")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "reviewedByFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Reviewed User"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.reviewedByFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "reviewedByFilter", $$v)
      },
      expression: "Filter.reviewedByFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Remark:")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-3",
    attrs: {
      "list": _vm.billedStatusList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Remark"
    },
    on: {
      "input": function($event) {
        _vm.getLockPanelDash('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.BilledRemark),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "BilledRemark", $$v)
      },
      expression: "Filter.BilledRemark"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getLockPanel,
      "fields": _vm.LockDashFields,
      "primary-key": "id_email_section",
      "per-page": _vm.pagination.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [(row0.item.isActive == '1' && row0.item.is_reviewed == 0) ? _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.AllModule_ids),
            expression: "AllModule_ids"
          }],
          attrs: {
            "type": "checkbox",
            "id": row0.item.extrapayment_id
          },
          domProps: {
            "value": row0.item.allModuleId,
            "checked": Array.isArray(_vm.AllModule_ids) ? _vm._i(_vm.AllModule_ids, row0.item.allModuleId) > -1 : (_vm.AllModule_ids)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.AllModule_ids,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = row0.item.allModuleId,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.AllModule_ids = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.AllModule_ids = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.AllModule_ids = $$c
              }
            }, function($event) {
              _vm.updateSelectAll($event, row0.item)
            }]
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n                  " + _vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage) + "\n                ")])]
      }
    }, {
      key: "JobNo",
      fn: function(row1) {
        return [_c('strong', {
          staticClass: "mr-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": row1.toggleDetails
          }
        }, [_vm._v("\n                  " + _vm._s(row1.item.JobNo) + "\n                  "), (row1.detailsShowing) ? _c('span', [_vm._v("\n                    ▼\n                    ")]) : _c('span', [_vm._v("\n                    ▶\n                    ")])]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(row1.item.JobDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Client Name:")]), _vm._v(" " + _vm._s(row1.item.ClientName)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row1.item.RaisedFrom)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Raised By:")]), _vm._v(" " + _vm._s(row1.item.RaisedBy)), _c('br'), _vm._v(" "), (_vm.$sessionsStorage.get('is_Mobile') != 'port') ? _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("\n                        Summary & Documents\n                      ")]) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JobNo": row1.item.JobNo,
            "PMC_JobDate": row1.item.JobDate,
            "PMC_JobType": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.ClientName,
            "PMC_Sline": row1.item.ShippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JobNo,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JobNo": row1.item.JobNo,
            "PMC_JobDate": row1.item.JobDate,
            "PMC_JobType": row1.item.JobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.ClientName,
            "PMC_Sline": row1.item.ShippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.allModuleId),
            "JobNo": row1.item.JOBNO
          }
        }) : _vm._e()]
      }
    }, {
      key: "EmailRemark",
      fn: function(row1) {
        return [(row1.item.email_contents) ? _c('b-button', {
          staticClass: "m-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "text": "View Mult-Billing",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showextra_paymentModal(
                row1.item.allModuleId,
                row1.item.email_contents,
                row1.item.doc_link,
                row1.item,
                row1.item.JobNo
              )
            }
          }
        }, [(row1.item.is_additional_task == 1) ? _c('b', [_vm._v("Additional Task")]) : (row1.item.is_expense == 1) ? _c('b', [_vm._v("Expense Task")]) : (row1.item.is_menifestation == 1) ? _c('b', [_vm._v("Manifestation Task")]) : (row1.item.is_slinepayment == 1) ? _c('b', [_vm._v("Sline Payment Task")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(_vm._s("Remarks : " + row1.item.EmailRemark) + "\n              ")]
      }
    }, {
      key: "CreatedDate",
      fn: function(row1) {
        return [_c('strong', [_vm._v("Created By:")]), _vm._v(" " + _vm._s(row1.item.CreatedByUser)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Created Date:")]), _vm._v(" " + _vm._s(row1.item.CreatedDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cleared By:")]), _vm._v(" " + _vm._s(row1.item.ClearedByUser)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cleared Date:")]), _vm._v(" " + _vm._s(row1.item.UpdatedDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Ass Close Reason:")]), _c('span', {
          domProps: {
            "innerHTML": _vm._s(row1.item.JobCloseReason)
          }
        }, [_vm._v(_vm._s(row1.item.JobCloseReason))])]
      }
    }, {
      key: "FirstUnlockUser",
      fn: function(row1) {
        return [_c('strong', [_vm._v("First Unlock Reason:")]), _vm._v("\n                " + _vm._s(row1.item.FirstUnlockReason)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("First Unlock User:")]), _vm._v(" " + _vm._s(row1.item.FirstUnlockUser)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("First Unlock Date:")]), _vm._v(" " + _vm._s(row1.item.FirstUnlockDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reviewed User:")]), _vm._v(" " + _vm._s(row1.item.ReviewedUser)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reviewed Date:")]), _vm._v(" " + _vm._s(row1.item.ReviewedDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Reviewed Status:")]), _vm._v(" " + _vm._s(row1.item.ReviewedStatus)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Billed Remark:")]), _vm._v(" " + _vm._s(row1.item.BilledRemark)), _c('br')]
      }
    }, {
      key: "row-details",
      fn: function(row1) {
        return [_c('b-card', [_c('b-row', [_c('b-col', [_c('strong', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row1.item.JobNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Job Type:")]), _vm._v(" " + _vm._s(row1.item.JobType)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Job Date:")]), _vm._v(" " + _vm._s(row1.item.JobDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Raised From:")]), _vm._v(" " + _vm._s(row1.item.RaisedFrom)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Bill Status:")]), _vm._v("\n                      " + _vm._s(row1.item.FinalBillingCompletedStatus)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Bill Type:")]), _vm._v(" " + _vm._s(row1.item.IsBillingTypeStatus)), _c('br')]), _vm._v(" "), _c('b-col', [_c('strong', [_vm._v("Client Name:")]), _vm._v(" " + _vm._s(row1.item.ClientName)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Sline Name:")]), _vm._v(" " + _vm._s(row1.item.ShippingLine)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Por:")]), _vm._v(" " + _vm._s(row1.item.Por)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Pol:")]), _vm._v(" " + _vm._s(row1.item.Pol)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Pod:")]), _vm._v(" " + _vm._s(row1.item.Pod)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fpod:")]), _vm._v(" " + _vm._s(row1.item.Fpod)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("MBL NO:")]), _vm._v(" " + _vm._s(row1.item.MblNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("HBL NO:")]), _vm._v(" " + _vm._s(row1.item.HblNo)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("MBL Date:")]), _vm._v(" " + _vm._s(row1.item.MblDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("MBL Release Date:")]), _vm._v(" " + _vm._s(row1.item.MblReleaseDate)), _c('br')]), _vm._v(" "), _c('b-col', [_c('strong', [_vm._v("Add Task:")]), _vm._v(" " + _vm._s(row1.item.AdditionalTaskStatus)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Sline:")]), _vm._v(" " + _vm._s(row1.item.SlinePaymentStatus)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Manifest:")]), _vm._v(" " + _vm._s(row1.item.MenifestationStatus)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Expense:")]), _vm._v(" " + _vm._s(row1.item.ExpenseStatus)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Payment Clear:")]), _vm._v(" " + _vm._s(row1.item.ActiveStatus)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Payment Remark:")]), _vm._v(" " + _vm._s(row1.item.EmailRemark)), _c('br'), _vm._v(" "), (row1.item.email_contents) ? _c('b-button', {
          staticClass: "m-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "text": "View Mult-Billing",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showextra_paymentModal(
                row1.item.allModuleId,
                row1.item.email_contents,
                row1.item.doc_link,
                row1.item,
                row1.item.JobNo
              )
            }
          }
        }, [(row1.item.is_additional_task == 1) ? _c('b', [_vm._v("Additional Task")]) : (row1.item.is_expense == 1) ? _c('b', [_vm._v("Expense Task")]) : (row1.item.is_menifestation == 1) ? _c('b', [_vm._v("Manifestation Task")]) : (row1.item.is_slinepayment == 1) ? _c('b', [_vm._v("Sline Payment Task")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('b-col', [_c('strong', [_vm._v("Created By:")]), _vm._v(" " + _vm._s(row1.item.CreatedByUser)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Created Date:")]), _vm._v(" " + _vm._s(row1.item.CreatedDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cleared By:")]), _vm._v(" " + _vm._s(row1.item.ClearedByUser)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Cleared Date:")]), _vm._v(" " + _vm._s(row1.item.UpdatedDate)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Payment Close Reason:")]), _c('span', {
          domProps: {
            "innerHTML": _vm._s(row1.item.PaymentCloseReason)
          }
        }, [_vm._v(_vm._s(row1.item.PaymentCloseReason))]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Ass Close Reason:")]), _c('span', {
          domProps: {
            "innerHTML": _vm._s(row1.item.JobCloseReason)
          }
        }, [_vm._v(_vm._s(row1.item.JobCloseReason))])]), _vm._v(" "), _c('b-col', [(
          row1.item.FreightContainers != 'null' ||
          row1.item.FreightContainers != null ||
          row1.item.FreightContainers != 'undefined' ||
          row1.item.FreightContainers != undefined
        ) ? _c('div', [(row1.item.FreightContainers) ? _c('div', {
          staticClass: "text-left"
        }, [(row1.item.FreightContainers) ? _c('div', _vm._l((row1.item.FreightContainers.split(',')), function() {
          return _c('span', {
            key: _vm.index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(_vm.item1 == "" ? "-------" : _vm.item1) + "\n                                ")])], 1)])
        })) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Type :")]), _vm._v("\n                        " + _vm._s(row1.item.FreightContainersType))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("SOB :")]), _vm._v(" " + _vm._s(row1.item.SOB))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Sys SOB :")]), _vm._v(" " + _vm._s(row1.item.SysSOB))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("SINV NO :")])]), _c('br'), _vm._v(" "), (row1.item.SINVNO) ? _c('div', _vm._l((row1.item.SINVNO.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2) + "\n                            ")])], 1)])
        })) : _c('span', [_vm._v("-----------")]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("SB NO :")]), _vm._v(" "), (row1.item.SBILLNO) ? _c('div', _vm._l((row1.item.SBILLNO.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2) + "\n                              ")])], 1)])
        })) : _vm._e()]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("CUST. SEAL NO :")]), _vm._v(" "), (row1.item.CUST_SEAL_NO) ? _c('div', _vm._l((row1.item.CUST_SEAL_NO.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2) + "\n                              ")])], 1)])
        })) : _vm._e()]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("LINE SEAL NO :")]), _vm._v(" "), (row1.item.LINE_SEAL_NO) ? _c('div', _vm._l((row1.item.LINE_SEAL_NO.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2) + "\n                              ")])], 1)])
        })) : _vm._e()]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("OE Date :")]), _vm._v("\n                        " + _vm._s(row1.item.OfFirstPaymentDate))]), _c('br'), _vm._v(" "), _c('span', [_c('strong', [_vm._v("MBL Release Date :")]), _vm._v("\n                        " + _vm._s(row1.item.MblReleaseDate))]), _c('br')])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalData
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-extra_payment",
    attrs: {
      "id": "modal-extra_payment",
      "title": "Extra Payment Details",
      "size": "lg",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [(_vm.extra_payment_Title) ? _c('h3', [_vm._v(_vm._s(_vm.extra_payment_Title))]) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.extra_payment_Arr)
    }
  }, [_vm._v(_vm._s(_vm.extra_payment_Arr))]), _vm._v(" "), (_vm.extra_payment_doc.length > 0) ? _c('b', [_c('u', [_c('h4', [_vm._v("Supporting Documents")])]), _c('br'), _vm._v(" "), _vm._l((_vm.extra_payment_doc.split(',')), function(item_doc, index_doc) {
    return _c('span', {
      key: index_doc
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.PrintValidity_Doc(item_doc, _vm.extra_payment_folder)
        }
      }
    }, [_vm._v("View Document - " + _vm._s(index_doc + 1))]), _c('br')])
  })], 2) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeextra_payment
    }
  }, [_vm._v("\n      Close")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-close-conf",
    attrs: {
      "id": "modal-close-conf",
      "title": 'Reviewed Confirmation',
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('label', [_vm._v("Remark:")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.reviewed_remark),
      callback: function($$v) {
        _vm.reviewed_remark = $$v
      },
      expression: "reviewed_remark"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.closeModalConfirm
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": !_vm.reviewed_remark,
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": _vm.closeReviewConfirmation
    }
  }, [_vm._v("\n          Proceed\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopClose",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.closeReviewConfirmation
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0c933ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/lockPannelDash.vue
// module id = 2838
// module chunks = 0